import React from 'react';
import {
  useNavigate,
} from 'react-router-dom';
import {
  Formik,
  Field,
} from 'formik';
import {
  useDispatch,
} from 'react-redux';
import * as Yup from 'yup';

import {
  coreActions,
} from '@gymcloud/core';

import {
  TextField,
  NamespaceLogo,
} from 'web-components';
import {
  Flex,
  Text,
} from 'web-styled';

import * as S from '../styled';

const validationSchema = Yup.object().shape({
  email: Yup.string()
    .email('Email must be a valid email')
    .required('Email is required'),
});

const ForgotPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <S.PageWrap>
      <NamespaceLogo />
      <S.FormWrap>
        <S.FormTitle>
          Forgot your password?
        </S.FormTitle>
        <Formik
          initialValues={{
            email: '',
          }}
          validationSchema={validationSchema}
          onSubmit={(
            values,
            callbacks,
          ) => {
            dispatch(coreActions.resetPasswordRequest(
              values,
              callbacks,
            ));
          }}
        >
          {(formikProps) => (formikProps.status === 'success'
            ? (
              <S.Reseted>
                <div>
                  Your password recovery instructions were
                  <br />
                  {' '}
                  sent to your email.
                </div>
                <S.SubmitButton onClick={() => navigate('/login')}>
                  Back to login
                </S.SubmitButton>
              </S.Reseted>
            ) : (
              <S.Form column onSubmit={formikProps.handleSubmit}>
                <Flex column width="100%" spacing={15}>
                  <S.TextCenter>
                    <Text>
                      Please enter your email address below and
                      <br />
                      we&apos;ll email you instructions on how to reset your password.
                    </Text>
                  </S.TextCenter>
                  <Field
                    name="email"
                    label="Email"
                    type="text"
                    color="#121827"
                    placeholder="Email address"
                    component={TextField}
                  />
                  <Flex
                    width="100%"
                    justify="space-between"
                    align="center"
                  >
                    <S.SubmitButton isLoading={formikProps.isSubmitting}>
                      Send
                    </S.SubmitButton>
                  </Flex>
                </Flex>
              </S.Form>
            )
          )}
        </Formik>
      </S.FormWrap>
    </S.PageWrap>
  );
};

export default ForgotPassword;
